import React from 'react'
import './TextInput.scss'

// eslint-disable-next-line quotes
interface Props extends React.ComponentProps<"input"> {
  placeholder?: string,
  onChangeText?: (s: string) => void,
  label?: string
}

const TextInput: React.FC<Props> = ({
  value = ``,
  type = `text`,
  onChangeText = () => {},
  label,
  ...otherProperties
}) => {

  const onChange = React.useCallback(
    ({ target: { value }}) => onChangeText(value),
    [onChangeText],
  )

  const input = (
    <input
      className="text-input"
      {...otherProperties}
      type={type}
      value={value}
      onChange={onChange}
    />
  )

  if(label){
    return (
      <div className="text-input-container">
        <label>
          <strong>{label}</strong>
        </label>
        {input}
      </div>
    )
  }

  return input
}

export default TextInput